// /src/components/NavBar.jsx
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { getAuth, signOut } from 'firebase/auth';
import './NavBar.css';

const Navbar = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  // NEW state for the logout confirmation modal
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  // Function to open the logout confirmation modal
  const handleLogoutClick = () => {
    setShowLogoutModal(true);
    setIsMenuOpen(false); // Close mobile menu if open
  };

  // Function to confirm and perform logout
  const confirmLogout = async () => {
    const auth = getAuth();
    await signOut(auth);
    navigate('/');
    setShowLogoutModal(false); // Close the modal
  };

  // Function to cancel logout
  const cancelLogout = () => {
    setShowLogoutModal(false); // Close the modal
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleLinkClick = () => {
    setIsMenuOpen(false);
  };

  // Determine the redirect path for the brand link
  const brandRedirectPath = user ? '/dashboard' : '/';

  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <Link to={brandRedirectPath} className="navbar-brand-link" onClick={handleLinkClick}>
          <img src="favicon.ico" alt="RocketPrep icon" className="app-icon" />
          RocketPrepAI
        </Link>
      </div>

      <button className="menu-toggle" onClick={toggleMenu} aria-label="Toggle navigation menu">
        <span className="hamburger-icon"></span>
        <span className="hamburger-icon"></span>
        <span className="hamburger-icon"></span>
      </button>

      <ul className={`navbar-links ${isMenuOpen ? 'open' : ''}`}>
        {user ? (
          <>
            <li><Link to="/dashboard" className="navbar-link" onClick={handleLinkClick}>Dashboard</Link></li>
            <li><Link to="/profile" className="navbar-link" onClick={handleLinkClick}>Profile</Link></li>
            <li>
              {/* Change onClick to open the modal */}
              <button onClick={handleLogoutClick} className="navbar-button logout-button">
                Log Out
              </button>
            </li>
          </>
        ) : (
          <>
            <li><Link to="/" className="navbar-link" onClick={handleLinkClick}>Home</Link></li>
            <li><Link to="/signup" className="navbar-link" onClick={handleLinkClick}>Sign Up</Link></li>
            <li><Link to="/login" className="navbar-button login-button" onClick={handleLinkClick}>Log In</Link></li>
          </>
        )}
      </ul>

      {/* NEW: Logout Confirmation Modal */}
      {showLogoutModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Confirm Logout</h3>
            <p>Are you sure you want to log out?</p>
            <div className="modal-buttons">
              <button onClick={confirmLogout} className="confirm-logout-button">Yes, Log Out</button>
              <button onClick={cancelLogout} className="cancel-logout-button">Cancel</button>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;